<template>
	<div class='h-card-gallery' :class='{"h-card-gallery--single": slides.length < 2}'>
		<div class='h-card-gallery-track' ref='track' @scroll.passive='onScroll'>
			<div class='h-card-gallery-slide' v-for='(slide, i) in slides' :key='slide'
				:style='i || !backdrop ? null : {backgroundImage: `url(${backdrop})`}'
			>
				<img
					:src='slide'
					:alt='alt'
					:loading='i ? "lazy" : "eager"'
					@error='onError(slide)'
				/>
			</div>
		</div>

		<template v-if='slides.length > 1'>
			<button type="button" class='h-card-gallery-arrow prev' @click.stop='move(-1)'>
				<v-icon icon='arrow-prev' size='14' />
			</button>
			<button type="button" class='h-card-gallery-arrow next' @click.stop='move(1)'>
				<v-icon icon='arrow-next' size='14' />
			</button>

			<ul class='h-card-gallery-dots'>
				<li v-for='(slide, i) in slides' :key='slide'
					class='h-card-gallery-dot'
					:class='{active: i === index}'
					@click.stop='scrollTo(i)'
				/>
			</ul>
		</template>
	</div>
</template>

<script>
	import { hotelImages } from '@/helpers/hotelImages';

	export default {
		data: () => ({
			index: 0,
			images: [],
			broken: [],
			// У части отелей фото отдаётся 403 — и в большом размере, и в
			// обычном. Тогда откатываемся на размер поменьше, а если и он
			// не открылся, показываем свою заглушку.
			firstBroken: false,
			previewBroken: false
		}),
		props: ['code', 'preview', 'alt'],
		computed: {
			// Первым кадром — тот же снимок, что в выдаче, но в большом размере:
			// изображение не подменяется, пока грузится, под ним лежит уже
			// показанная миниатюра.
			first() {
				if (this.previewBroken) return this.noPhoto;
				if (this.firstBroken) return this.preview;

				return this.preview.replace('/giata/', '/giata/bigger/');
			},
			noPhoto() {
				return require('@/assets/hotel/no-photo.webp');
			},
			// Фон-подложку убираем, если сама миниатюра битая.
			backdrop() {
				return this.previewBroken ? null : this.preview;
			},
			slides() {
				let images = this.images.filter(image => !this.broken.includes(image) && image !== this.first);

				// Миниатюра не открылась ни в одном размере — заглушка только если
				// других живых кадров нет, иначе она висела первым слайдом.
				if (this.previewBroken) {
					return images.length ? images : [this.noPhoto];
				}

				return [this.first, ...images];
			}
		},
		mounted() {
			this.observe();
		},
		beforeDestroy() {
			if (this.observer) this.observer.disconnect();
		},
		methods: {
			// Фото грузим только для карточек, до которых доскроллили.
			observe() {
				if (!('IntersectionObserver' in window)) return this.load();

				this.observer = new IntersectionObserver(entries => {
					if (!entries.some(entry => entry.isIntersecting)) return;

					this.observer.disconnect();
					this.load();
				}, {rootMargin: '200px'});

				this.observer.observe(this.$el);
			},
			load() {
				if (!this.code) return;

				hotelImages(this.code).then(images => this.images = images);
			},
			// Листание — обычный горизонтальный скролл со snap: на телефоне
			// это родной свайп с инерцией, на десктопе — стрелки и трекпад.
			scrollTo(index) {
				let track = this.$refs.track;
				if (!track) return;

				track.scrollTo({left: track.clientWidth * index, behavior: 'smooth'});
			},
			move(step) {
				let last = this.slides.length - 1;
				let next = this.index + step;

				this.scrollTo(next < 0 ? last : (next > last ? 0 : next));
			},
			onScroll() {
				let track = this.$refs.track;
				if (!track || !track.clientWidth) return;

				this.index = Math.round(track.scrollLeft / track.clientWidth);
			},
			onError(image) {
				if (image === this.noPhoto) return;

				// Битым помечаем и первый кадр: тот же адрес есть в списке фото отеля и
				// иначе вылезал бы слайдом. Vue переиспользует упавший <img> с тем же
				// ключом и src, повторного error браузер не шлёт — кадр так и висел битым.
				this.broken = [...this.broken, image];

				if (image === this.first) {
					if (!this.firstBroken) return this.firstBroken = true;

					return this.previewBroken = true;
				}

				this.index = 0;
			}
		}
	}
</script>
